import { Component } from '@angular/core';
import { AuthService } from './_services/auth/auth.service';
import { LocalStorageService } from './_services/localStorage/local-storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(
    public authService: AuthService,
    public localStorageService: LocalStorageService
  ) {}

  get isAuthorized() {
    return this.authService.isUserAuthorized;
  }
}
